<div class="loop-block">
  <h2 class="text__sm fw__600">Loop Through</h2>

  <mat-radio-group aria-label="Select an option" class="loop-block__radio-group" data-testid="loop-source-radio-group" (change)="onSetSource($event.value)">
    @for (option of blockLoopSourceOptions; track option.value) {
      <mat-radio-button
        color="primary"
        [checked]="option.value === sourceType$()"
        [value]="option.value"
        [attr.data-testid]="'loop-source-' + option.value + '-radio'"
        class="loop-block__radio-group__button"
      >
        <div>
          <span class="text__sm fw__500">{{ option.text }}</span>
        </div>
      </mat-radio-button>
    }
  </mat-radio-group>

  @if (sourceType$() === blockLoopSourceEnum.Media) {
    <div class="loop-block__stimulus-content">
      <empathy-loop-stimuli [block]="activeBlock()" />
      @if (stimulusCount$()) {
        <section class="loop-block__presentation" [attr.aria-labelledby]="'loop-presentation-' + activeBlock().value.id">
          <div class="loop-block__presentation-header">
            <h2 [id]="'loop-presentation-' + activeBlock().value.id" class="text__sm fw__600"><span>Stimuli Presentation &amp; Distribution</span></h2>
            <button
              #settingsTrigger
              mat-stroked-button
              type="button"
              class="loop-block__settings-button"
              data-testid="loop-settings-open-button"
              (click)="onOpenSettings($any($event.currentTarget))"
            >
              <fa-icon [icon]="faSliders" />
              <span>Settings</span>
            </button>
          </div>
          <div class="loop-block__presentation-summary text__sm">
            <mat-slide-toggle
              [formControl]="activeBlock().controls.sourceOptionsRandomizedInd"
              color="primary"
              labelPosition="before"
              data-testid="loop-randomized-toggle"
              (change)="onRandomizationChanged()"
            >
              <span class="caption">Randomize</span>
            </mat-slide-toggle>
            <span class="loop-block__summary-item">
              <span class="caption">Per participant</span>
              <span class="fw__600">{{ quantitySummary$() }}</span>
            </span>
            <span class="loop-block__summary-item">
              <span class="caption">Min. exposures</span>
              <span class="fw__600">{{ targetSummary$() }}</span>
            </span>
          </div>
          <p class="loop-block__presentation-description text__sm caption" data-testid="loop-presentation-description">
            <span>Each participant sees&nbsp;</span>
            <span class="fw__600">{{ participantQuantitySummary$() }}</span>
            <span>&nbsp;in {{ presentationOrder$() }}.</span>
            <span>&nbsp;Every response is tagged with its stimulus ID.</span>
          </p>
        </section>
      }
      <div class="loop-block__stimulus-questions">
        <ng-container *ngTemplateOutlet="useQuestions" />
      </div>
    </div>
  }

  @if (sourceQuestion$() && sourceType$() === blockLoopSourceEnum.Question) {
    <div class="loop-block__source-question">
      <fa-icon [icon]="questionTypeConfig[sourceQuestion$().type].icon"></fa-icon>
      <span class="loop-block__source-question-title">
        <span class="text__sm fw__600">{{ sourceQuestion$().code }}.</span>
        <span class="loop-block__source-question-text survey-editor__html-content text__sm fw__400" [innerHTML]="sourceQuestion$().title | toPlainText"></span>
      </span>

      <button mat-icon-button title="Reset source Question" data-testid="loop-source-reset-button" color="primary" (click)="onResetSourceQId()">
        <fa-icon [icon]="faRefresh"></fa-icon>
      </button>
    </div>
  } @else if (sourceType$() === blockLoopSourceEnum.Question) {
    <div class="editor-question-form__input">
      @if (this.siblingWithoutQuestions$()) {
        <span class="oop-block__source-question-not-available text__sm fw__ 500">
          Loop questions can only reference options from earlier questions. Please make sure there’s at least one question with selectable options positioned
          before this one.
        </span>
      } @else {
        <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
          <input
            #input
            data-testid="loop-source-question-input"
            matInput
            [matAutocomplete]="auto"
            type="text"
            placeholder="Select a question"
            aria-label="Select a question"
            (input)="filter()"
            (focus)="filter()"
          />
          <mat-autocomplete
            requireSelection
            #auto="matAutocomplete"
            class="eiq-no-wrap-option"
            [classList]="'eiq-no-wrap-option'"
            (optionSelected)="onSourceQuestionSelected($event)"
          >
            @for (prevQuestion of filteredQuestions$(); track prevQuestion.id) {
              <mat-option [value]="prevQuestion.id" [attr.data-testid]="'loop-source-question-' + prevQuestion.id + '-option'">
                {{ prevQuestion.code }} - {{ prevQuestion.title | toPlainText }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }
    </div>
  }

  @if (sourceType$() === blockLoopSourceEnum.Question && activeBlock().value.sourceQId) {
    <ng-container *ngTemplateOutlet="useQuestions"></ng-container>
  }

  @if (sourceType$() === blockLoopSourceEnum.Options) {
    <empathy-custom-options-form
      [lastOptionIndex]="activeBlock().controls.lastOptionIndex"
      [customOptions]="activeBlock().controls.sourceOptions | toFormArray"
      [randomized]="activeBlock().controls.sourceOptionsRandomizedInd | toFormControl"
    ></empathy-custom-options-form>

    <ng-container *ngTemplateOutlet="useQuestions"></ng-container>
  }
</div>

<ng-template #useQuestions>
  <h2 class="text__sm fw__600">
    <span>Questions</span>
    @if (sourceType$() === blockLoopSourceEnum.Media) {
      <span class="loop-block__required" aria-hidden="true">*</span>
    }
  </h2>
  <empathy-block-questions [activeBlock]="activeBlock()" [isSecondChild]="isSecondChild()" />
</ng-template>
